module.exports = __webpack_public_path__ + "img/icon_unmute.204f40c1.svg";